import { useState } from 'react'
import './style.css'

const faqs = [
  {
    question: 'Where is Life Sports Club located?',
    answer: 'Life Sports Club is located in New Cairo, Egypt — a 25-acre world-class sports facility.',
  },
  {
    question: 'What sports are available at the club?',
    answer: 'We offer 20+ sports including tennis, padel, football, swimming in Olympic-standard pools, squash, pickleball, and many more.',
  },
  {
    question: 'How do I become a member?',
    answer: 'Life Sports Club is a referral-based club. You need a valid referral code from an existing member to apply for membership. Enter your code on the membership page to get started.',
  },
  {
    question: 'Are there sports academies for kids and adults?',
    answer: 'Yes — we offer professional sports academies for both kids and adults across multiple disciplines, coached by experienced trainers.',
  },
  {
    question: 'Does the club have swimming pools?',
    answer: 'Yes, Life Sports Club features Olympic-standard swimming pools available to all members.',
  },
]

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="faq-section" aria-label="Frequently Asked Questions">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item${openIndex === index ? ' faq-item--open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => toggle(index)}
              aria-expanded={openIndex === index}
            >
              {faq.question}
              <span className="faq-icon" aria-hidden="true">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
